package com.example.monetix.utils

import com.example.monetix.db.MonetixDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

class SmartLocationEngine(private val db: MonetixDatabase, private val tracker: LocationTracker) {

    // 1. Chiamiamo questa quando salviamo una transazione (per "imparare" il posto)
    suspend fun learnMerchantLocation(merchantKey: String, categoryId: String, subcategoryText: String?) {
        val location = tracker.getCurrentLocation() ?: return // Se non ho segnale GPS, rinuncio silenziosamente

        // 🚀 Usiamo Dispatchers.Default che in KMP funziona su tutte le piattaforme!
        withContext(Dispatchers.Default) {
            val now = kotlinx.datetime.Clock.System.now().toEpochMilliseconds()

            // Controlla se il merchant esiste già
            val existing = db.merchantLocationQueries.getLocationByMerchant(merchantKey).executeAsOneOrNull()

            if (existing != null) {
                // Aggiorna le coordinate (magari il supermercato è grande e la cassa è un po' più in là)
                db.merchantLocationQueries.insertOrUpdate(
                    merchantKey = merchantKey,
                    categoryId = categoryId,
                    subcategoryText = subcategoryText,
                    latitude = location.latitude,
                    longitude = location.longitude,
                    visitCount = existing.visitCount + 1,
                    lastVisitedEpochMs = now
                )
            } else {
                // Nuovo negozio scoperto!
                db.merchantLocationQueries.insertOrUpdate(
                    merchantKey = merchantKey,
                    categoryId = categoryId,
                    subcategoryText = subcategoryText,
                    latitude = location.latitude,
                    longitude = location.longitude,
                    visitCount = 1,
                    lastVisitedEpochMs = now
                )
            }
        }
    }

    // 2. Chiamiamo questa quando apriamo la schermata "Aggiungi Spesa"
    suspend fun suggestMerchantNearby(): String? {
        val location = tracker.getCurrentLocation() ?: return null

        return withContext(Dispatchers.Default) {
            val allLocations = db.merchantLocationQueries.getAllLocations().executeAsList()

            // Cerca il negozio più vicino (entro un raggio di tolleranza, es. 200 metri)
            val nearbyMerchant = allLocations.map { loc ->
                val distance = calculateDistanceInMeters(location, GpsLocation(loc.latitude, loc.longitude))
                Pair(loc, distance)
            }
                .filter { it.second < 200.0 } // Tolleranza di 200 metri
                .minByOrNull { it.second } // Prende il più vicino in assoluto se ce n'è più di uno

            nearbyMerchant?.first?.merchantKey
        }
    }
}